import { render, staticRenderFns } from "./InPendingArticles.vue?vue&type=template&id=1a0fee30&scoped=true"
import script from "./InPendingArticles.vue?vue&type=script&lang=js"
export * from "./InPendingArticles.vue?vue&type=script&lang=js"
import style0 from "./InPendingArticles.vue?vue&type=style&index=0&id=1a0fee30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a0fee30",
  null
  
)

export default component.exports